var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.type === "determined"
    ? _c(
        "div",
        {
          staticClass: "ob1-spinner-determined",
          attrs: {
            "data-ob1-component": "SpinnerDetermined",
            "data-spinnerdetermined-timer": _vm.timer,
            role: "status",
          },
        },
        [
          _c("p", { staticClass: "visually-hidden" }, [
            _vm._v("\n        Chargement en cours...\n    "),
          ]),
        ]
      )
    : _c("div", [
        _c(
          "svg",
          {
            staticClass: "ob1-spinner-undetermined",
            style: `width:${_vm.sizeWithUnit}; height:${_vm.sizeWithUnit}`,
            attrs: {
              viewBox: "0 0 50 50",
              focusable: "false",
              "aria-hidden": "true",
            },
          },
          [
            _c("circle", {
              staticClass: "ob1-spinner-undetermined-circle",
              attrs: { cx: "25", cy: "25", r: "20" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "visually-hidden" }, [
          _vm._v("\n        Chargement en cours...\n    "),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }